import { Route } from '@angular/router';

export interface SidebarRoute extends Route {
  iconClass?: string;
  hidden?: boolean;
  text: string;
  hasChildren?: boolean;
}
